var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vertical-bar-chart-container"},[_c('canvas',{ref:"chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }